import styles from './LeaderboardModal.module.css'
import Modal from "../../../components/Modal/Modal.tsx";

const LeaderboardModal = () => {

    return (
        <Modal noTopPadding={true}>
            <div className={styles.container}>
                <div className={styles.title}>Список наград</div>
                <div className={styles.stepsContainer}>
                    <div className={styles.stepsTitle}>Награды в период 01 - 31 сентября</div>
                    <div className={styles.stepsSubtitle}>Награды выдаются 1-го числа каждого месяца</div>
                    <div className={styles.entriesContainer}>
                        <div className={styles.rewardsList}>
                            {/* 1st Place */}
                            <div className={styles.listEntry}>
                                <div className={styles.rank}>
                                    <div className={styles.first}></div>
                                    <p>1</p>
                                </div>
                                <div className={styles.reward}>
                                    <div className={styles.rewardBlock}>
                                        <div className={styles.nft}></div>
                                        <p>NFT</p>
                                    </div>
                                    <div className={styles.rewardLine}></div>
                                    <div className={styles.coins}>
                                        <div className={styles.coinIconSmall}></div>
                                        <span className={styles.coinValue}>15,000</span>
                                    </div>
                                </div>

                            </div>

                            {/* 2nd Place */}
                            <div className={styles.listEntry}>
                                <div className={styles.rank}>
                                    <div className={styles.second}></div>
                                    <p>2</p>
                                </div>
                                <div className={styles.reward}>
                                    <div className={styles.rewardBlock}>
                                        <div className={styles.usdt}></div>
                                        <p>5</p>
                                    </div>
                                    <div className={styles.coins}>
                                        <div className={styles.coinIconSmall}></div>
                                        <span className={styles.coinValue}>10,000</span>
                                    </div>
                                </div>
                            </div>

                            {/* 3rd Place */}
                            <div className={styles.listEntry}>
                                <div className={styles.rank}>
                                    <div className={styles.third}></div>
                                    <p>3</p>
                                </div>
                                <div className={styles.reward}>
                                    <div className={styles.rewardBlock}>
                                        <div className={styles.usdt}></div>
                                        <p>3</p>
                                    </div>
                                    <div className={styles.coins}>
                                        <div className={styles.coinIconSmall}></div>
                                        <span className={styles.coinValue}>10,000</span>
                                    </div>
                                </div>
                            </div>

                            {/* 4-10 Place */}
                            <div className={styles.listEntry}>
                                <div className={styles.rank}>
                                    <p>4-10</p>
                                </div>
                                <div className={styles.reward}></div>
                                <div className={styles.coins}>
                                    <span className={styles.coinValue}>5,000</span>
                                </div>
                            </div>

                            {/* 11-20 Place */}
                            <div className={styles.listEntry}>
                                <div className={styles.rank}>
                                    <p>11-20</p>
                                </div>
                                <div className={styles.reward}></div>
                                <div className={styles.coins}>
                                    <span className={styles.coinValue}>2,500</span>
                                </div>
                            </div>

                            {/* 21-50 Place */}
                            <div className={styles.listEntry}>
                                <div className={styles.rank}>
                                    <p>21-50</p>
                                </div>
                                <div className={styles.reward}></div>
                                <div className={styles.coins}>
                                    <span className={styles.coinValue}>1,000</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
)
}

export default LeaderboardModal